
export function handleHttpResponse(response){
    return response.text().then(text => {
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                window.location.href = window.location.href;
                return false;
            } else if (response.status === 403) {
                return Promise.reject("Permission denied.");
            } else if (response.status === 502) {
                return Promise.reject("Gateway error. The server is temporary unavailable.");
            } else if (response.status === 503) {
                return Promise.reject("Gateway error. The server is temporary unavailable.");
            } else if (response.status === 504) {
                return Promise.reject("Gateway error. The server is temporary unavailable.");
            } else {
                var data;
                try{
                    data = text && JSON.parse(text);
                } catch(err) {
                    return Promise.reject("Failed to parse response: " + err);
                }
                var error = "";
                if (data && data.error){
                    error = `${data.error}`;
                    if (data.message){
                        error += ` ${data.message}`;
                    }
                } else if(data && data.msg && data.msg.error){
                    error = data && data.msg && data.msg.error;
                } else {
                    error = response.statusText || "Connection failed. Http-code: " + response.status;
                }
                // const error = (data && data.error) || (data && data.msg && data.msg.error) || response.statusText;
                console.error('http-helper error', response, error);
                // throw new Error("ERR: " + error);
                return Promise.reject(error);
            }
        } else {
            try{
                return text && JSON.parse(text);
            } catch(err) {
                return Promise.reject("Failed to parse response: " + err);
            }
        }

    });
};

export function handleHttpResponseAcceptAuthError(response){
    return response.text().then(text => {
        if (!response.ok) {
            if (response.status === 502) {
                return Promise.reject("Gateway error. The server is temporary unavailable.");
            } else if (response.status === 503) {
                return Promise.reject("Gateway error. The server is temporary unavailable.");
            } else if (response.status === 504) {
                return Promise.reject("Gateway error. The server is temporary unavailable.");
            } else {
                var data;
                try{
                    data = text && JSON.parse(text);
                } catch(err) {
                    return Promise.reject("Failed to parse response: " + err);
                }
                var error = "";
                if (data && data.error){
                    error = `${data.error}`;
                    if (data.message){
                        error += ` ${data.message}`;
                    }
                } else if(data && data.msg && data.msg.error){
                    error = data && data.msg && data.msg.error;
                } else {
                    error = response.statusText || "Connection failed. Http-code: " + response.status;
                }
                // const error = (data && data.error) || (data && data.msg && data.msg.error) || response.statusText;
                console.error('http-helper error', response, error);
                // throw new Error("ERR: " + error);
                return Promise.reject(error);
            }
        } else {
            try{
                return text && JSON.parse(text);
            } catch(err) {
                return Promise.reject("Failed to parse response: " + err);
            }
        }

    });
};

export function handleFhirResponse(response) {
    console.log('handleFhirResponse', response);
    return response.text().then(text => {
        var data;
        try{
            data = text && JSON.parse(text);
        } catch(err) {
            return Promise.reject("Failed to parse response: " + err);
        }

        if (!response.ok) {
            if (data.resourceType === "OperationOutcome" ){
                console.error("Received OperationOutcome", data);
                console.error(data.text);
                console.error(data.text.div);

                if (data.issue && data.issue.length > 0){
                    return Promise.reject(data.issue[0].diagnostics);
                }

                // if (data.text && data.text.div){
                //     console.log('rejecting', data.text.div);
                //     return Promise.reject(data.text.div);
                // } else if (data.issue && data.issue.length > 0){
                //     return Promise.reject(data.issue[0].diagnostics);
                // }
            }

            var error = response.statusText;
            if (data.message){
                error += ". " + data.message;
            }

            // throw new Error("ERR: " + error);
            return Promise.reject(error);
        }

        return data;
    });
}


export function handleHttpRawResponse(response){
    return response.text().then(text => {
        if (!response.ok) {
            if (response.status === 401) {
                const goto = "/api/account/authorize/?url=" + encodeURIComponent(window.location.pathname + window.location.search);
                console.log("Not authenticated, going to " + goto);
                window.location.replace(goto)
                return false;
            }

            // if (response.status === 401) {
            //     // auto logout if 401 response returned from api
            //     const goto =  "/auth.php?url=" + encodeURIComponent(window.location.pathname + window.location.search);
            //
            //     console.error("Not authenticated");
            //     // alert('not authenticated');
            //     window.location.replace(goto)
            //     return false;
            // } else if (response.status === 403) {
            //     console.log('Permission denied. ');
            //     window.location.replace("/form/");
            //     return false;
            // }

            const error = response.statusText;
            console.log('http-helper error', error);
            // throw new Error("ERR: " + error);
            return Promise.reject(error);
        }

        return text;
    });
};

export function getQueryParams() {
    var query = window.location.search;
    var params = {};
    if (query){
        if (query.startsWith("\?")){
            query = query.substr(1);
            const parts = query.split('&');
            for (var i=0; i<parts.length; i++){
                if (parts[i]){
                    try{
                        const [name, value] = parts[i].split('=');
                        params[decodeURIComponent(name)] = decodeURIComponent(value.replace(/\+/g, '%20'));
                    }catch (e) {
                    }
                }

            }
        }
    }
    return params;
};

export function getQueryString(params){
    const items = [];
    for (const key in params){
        items.push(`${key}=${encodeURIComponent(params[key])}`);
    }
    return items.join("&");
}

